import Vue from "vue";
import VueRouter from "vue-router";
import { isMobile } from "../utils/tools.js";

Vue.use(VueRouter);

/* Layout */
import AdminLayout from "@/views/default/layout/AdminLayout";
import MemberLayout from "@/views/default/layout/MemberLayout";
import AgentLayout from "@/views/default/layout/AgentLayout";
import BlankLayout from "@/views/default/layout/BlankLayout";
import MobileLayout from "@/views/default/mobile/layout/MobileLayout";
import EmployeeLayout from "@/views/default/layout/EmployeeLayout";

export const offlineRoutes = [
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: "tour" */ "../views/tour/Index"),
  },
];

export const constantRoutes = [
  {
    path: "/",
    name: "Index",
    component: () => import(/* webpackChunkName: "mobIndex" */ "@/views/default/portal/index"),
  },
  /*{
    path: "/pano",
    name: "Pano",
    component: () => import(/!* webpackChunkName: "pano" *!/ "@/views/default/portal/pano"),
  },
  {
    path: "/authors",
    name: "Author",
    component: () => import(/!* webpackChunkName: "author" *!/ "@/views/default/portal/author"),
  },
  {
    path: "/author/:id",
    name: "AuthorDetails",
    component: () => import(/!* webpackChunkName: "authorDetails" *!/ "@/views/default/portal/authorDetails"),
  },*/
  {
    path: "/news/:cate",
    name: "New",
    component: () => import(/* webpackChunkName: "news" */ "@/views/default/portal/news"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import(/* webpackChunkName: "news" */ "@/views/default/portal/news"),
  },
  {
    path: "/download",
    name: "Download",
    component: () => import(/* webpackChunkName: "download" */ "@/views/default/portal/download"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import(/* webpackChunkName: "download" */ "@/views/default/policy/PrivacyPolicy"),
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import(/* webpackChunkName: "download" */ "@/views/default/policy/UserAgreement"),
  },
  {
    path: "/new/:id",
    name: "NewsDetails",
    component: () => import(/* webpackChunkName: "newsDetails" */ "@/views/default/portal/newsDetails"),
  },
  {
    path: "/tour/:id",
    name: "Tour",
    component: () =>
      import(/* webpackChunkName: "tour" */ "../views/tour/Index"),
  },
  {
    path: "/vrtour/:id/:role/:houseId",
    name: "VRTour",
    component: () =>
      import(/* webpackChunkName: "tour" */ "../views/tour/Index"),
  },
  {
    path: "/edit",
    name: "Edit",
    component: () => import(/* webpackChunkName: "edit" */ "../views/edit"),
  },
  {
    path: "/mobile/edit",
    name: "EditMob",
    component: () =>
      import(/* webpackChunkName: "edit" */ "../views/edit/indexMobile"),
  },
  {
    path: "/404",
    component: () =>
      import(/* webpackChunkName: "notFound" */ "@/views/default/error/404"),
    hidden: true,
  },
  // {
  //   path: "/hint/:type",
  //   component: () =>
  //     import(/* webpackChunkName: "notFound" */ "@/views/default/error/hint"),
  //   hidden: true,
  // },
];

export const employeeRoutes = [
  {
    path: "/employee",
    redirect: "/employee/home",
    component: EmployeeLayout,
    children: [
      {
        path: "pcpublish",
        name: "pcpublish",
        redirect: "pcpublish/index",
        component: BlankLayout,
        hidden: true,
        children: [
          {
            path: "index",
            component: () =>
              import(
                /* webpackChunkName: "pcPublish" */ "../views/default/publish/pc_publish"
              ),
            meta: { title: "pcpublish", icon: "cloud-upload", type: "pc" },
          },
        ],
      },
      {
        path: "home",
        name: "employee-home",
        redirect: "home/dashboard",
        component: BlankLayout,
        meta: { title: "home" },
        children: [
          {
            path: "dashboard",
            component: () =>
              import(
                /* webpackChunkName: "memberDashboard" */ "@/views/default/employee/home/Dashboard"
              ),
            meta: { title: "dashboard", icon: "area-chart" },
          },
        ],
      },
      {
        path: "work",
        redirect: "work/list",
        component: BlankLayout,
        meta: { title: "work" },
        children: [
          {
            path: "list",
            component: () =>
              import(
                /* webpackChunkName: "memberWork" */ "@/views/default/employee/work/List"
              ),
            meta: { title: "workList", icon: "appstore" },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "memberRecycle" */ "@/views/default/employee/work/Recycle"
              ),
            meta: { title: "workRecycle", icon: "delete" },
          },
        ],
      },
      {
        path: "material",
        redirect: "material/pano_list",
        component: BlankLayout,
        meta: { title: "material" },
        children: [
          {
            path: "pano_list",
            component: () =>
              import(
                /* webpackChunkName: "memberPanoList" */ "@/views/default/components/material/PanoList"
              ),
            meta: { title: "panoList", icon: "global" },
          },
          {
            path: "panoramic_video",
            component: () =>
              import(
                /* webpackChunkName: "memberPanoramicList" */ "@/views/default/components/material/Panoramic"
              ),
            meta: { title: "panoramic", icon: "codepen-circle" },
          },
          {
            path: "image_list",
            component: () =>
              import(
                /* webpackChunkName: "memberImageList" */ "@/views/default/components/material/ImageList"
              ),
            meta: { title: "imageList", icon: "picture" },
          },
          {
            path: "video_list",
            component: () =>
              import(
                /* webpackChunkName: "memberVideoList" */ "@/views/default/components/material/VideoList"
              ),
            meta: { title: "videoList", icon: "video-camera" },
          },
          {
            path: "audio_list",
            component: () =>
              import(
                /* webpackChunkName: "memberAudioList" */ "@/views/default/components/material/AudioList"
              ),
            meta: { title: "audioList", icon: "audio" },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "memberRecycle" */ "@/views/default/components/material/Recycle"
              ),
            meta: { title: "recycle", icon: "delete" },
          },
        ],
      },
      {
        path: "account",
        name: "employee-account",
        redirect: "account/basic",
        component: BlankLayout,
        meta: { title: "account" },
        children: [
          {
            path: "basic",
            component: () =>
              import(
                /* webpackChunkName: "memberBasic" */ "@/views/default/employee/account/Basic"
              ),
            meta: { title: "accountBasic", icon: "exception" },
          },
          {
            path: "secure",
            component: () =>
              import(
                /* webpackChunkName: "memberSecure" */ "@/views/default/employee/account/Secure"
              ),
            meta: { title: "accountSecure", icon: "safety" },
          },
          {
            path: "order",
            component: () =>
              import("@/views/default/components/OrderDetail/index"),
            meta: { title: "orderDetail", icon: "safety" ,type:1},
          },
        ],
      },
      {
        path: "hint",
        // name: "member-account",
        redirect: "hint/hintPage",
        component: BlankLayout,
        meta: { title: "hintMessage" },
        hidden: true,
        children: [
          {
            path: "hintPage",
            component: () =>
              import(/* webpackChunkName: "notFound" */ "@/views/default/error/hint"),
              meta: { title: "hintMessage", icon: "safety"},
          },
        ],
      },
    ],
  },
];

export const memberRoutes = [
  {
    path: "/member",
    redirect: "/member/home",
    component: MemberLayout,
    children: [
      {
        path: "pcpublish",
        name: "pcpublish",
        redirect: "pcpublish/index",
        component: BlankLayout,
        hidden: true,
        children: [
          {
            path: "index",
            component: () =>
              import(
                /* webpackChunkName: "pcPublish" */ "../views/default/publish/pc_publish/index"
              ),
            meta: { title: "roampublish", icon: "cloud-upload", type: "pc" },
          },
          {
            path: "live",
            name:"live",
            component: () =>
              import(
                /* webpackChunkName: "pcPublish" */ "../views/default/publish/pc_publish/live"
              ),
              meta: { title: "pclive", icon: "video-camera", type: "pc" },
          },
        ],
      },
      {
        path: "home",
        name: "member-home",
        redirect: "home/dashboard",
        component: BlankLayout,
        meta: { title: "home" },
        children: [
          {
            path: "dashboard",
            component: () =>
              import(
                /* webpackChunkName: "memberDashboard" */ "@/views/default/member/home/Dashboard"
              ),
            meta: { title: "dashboard", icon: "area-chart" },
          },
        ],
      },
      {
        path: "work",
        redirect: "work/list",
        component: BlankLayout,
        meta: { title: "work" },
        children: [
          {
            path: "list",
            component: () =>
              import(
                /* webpackChunkName: "memberWork" */ "@/views/default/member/work/List"
              ),
            meta: { title: "workList", icon: "appstore" },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "memberRecycle" */ "@/views/default/member/work/Recycle"
              ),
            meta: { title: "workRecycle", icon: "delete" },
          },
        ],
      },
      // 員工管理
      //#region
      /*{
        path: 'manager',
        redirect: 'manager/userlist',
        component: BlankLayout,
        meta: {title: 'employeeManage'},
        children: [
          {
            path: 'userlist',
            component: () => import ("@/views/default/member/manager/Userlist"),
            meta: {title: "employeeManageUserList", icon: "user" }
          },
          {
              path: "detail",
              component: () =>
                  import(
                      /* webpackChunkName: "agentUserDetail"  "@/views/default/member/manager/Detail"
                      ),
              meta: { title: "userDetail", icon: "hdd", showBreadcrumb: true,hidden: true },
          },
          {
              path: "config",
              component: () =>
                  import(
                      /* webpackChunkName: "agentConfig"  "@/views/default/member/manager/Config"
                      ),
              meta: { title: "userConfig", icon: "hdd",showBreadcrumb: true, hidden: true },
          },
          {
            path: 'userconfig',
            component: () => import ("@/views/default/member/manager/Userconfig"),
            meta: {title: "employeeManageUserconfig", icon: "control"}
          },
          {
            path: 'order',
            component: () => import("@/views/default/components/OrderDetail/index"),
            meta: {title: "employeeManageOrder", icon: "security-scan",type:2}
          },
          {
            path: 'userrecycle',
            component: () => import ("@/views/default/member/manager/Userrecycle"),
            meta: {title: "employeeManageUserrecycle", icon: "delete"}
          }
        ]
      },*/
      //#endregion
      //作品管理
      {
        path: "workManage",
        redirect: "workManage/workList",
        component: BlankLayout,
        meta: { title: "workManage" },
        hidden:true,
        children: [
          {
            path: "workList",
            component: () => import("@/views/default/components/WorkManage/WorkList"),
            meta: {
              title: "workList",
              icon: "project",
              showBreadcrumb: false,
            },
          },
          {
            path: "workRecycle",
            component: () => import("@/views/default/components/WorkManage/WorkRecycle"),
            meta: { title: "workRecycle", icon: "delete" },
          },
        ],
      },
      //專案
      {
        path: "project",
        redirect: "project/list",
        component: BlankLayout,
        meta: { title: "project" },
        level: 0,
        children: [
          {
            path: "list",
            component: () =>
                import(
                    /* webpackChunkName: "memberWork" */ "@/views/default/member/project/List"
                    ),
            meta: { title: "projectList", icon: "appstore" },
          },
        ],
      },
      //客戶管理
      {
        path: "customer",
        redirect: "customer/list",
        component: BlankLayout,
        meta: { title: "customer" },
        level: 0,
        children: [
          {
            path: "list",
            component: () =>
                import(
                    /* webpackChunkName: "memberWork" */ "@/views/default/member/customer/List"
                    ),
            meta: { title: "customerList", icon: "appstore" },
          },
        ],
      },
      //素材
      {
        path: "material",
        redirect: "material/pano_list",
        component: BlankLayout,
        meta: { title: "material" },
        children: [
          {
            path: "pano_list",
            component: () =>
              import(
                /* webpackChunkName: "memberPanoList" */ "@/views/default/components/material/PanoList"
              ),
            meta: { title: "panoList", icon: "global" },
          },
          {
            path: "panoramic_video",
            component: () =>
              import(
                /* webpackChunkName: "memberPanoramicList" */ "@/views/default/components/material/Panoramic"
              ),
            meta: { title: "panoramic", icon: "codepen-circle" },
          },
          // 全景直播
          {
            path: "panoramic_live",
            component: () =>
              import(
                /* webpackChunkName: "memberPanoramicList" */ "@/views/default/components/material/PanoramicLive"
              ),
            meta: { title: "PanoramicLive", icon: "video-camera" },
          },
          {
            path: "image_list",
            component: () =>
              import(
                /* webpackChunkName: "memberImageList" */ "@/views/default/components/material/ImageList"
              ),
            meta: { title: "imageList", icon: "picture" },
          },
          {
            path: "video_list",
            component: () =>
              import(
                /* webpackChunkName: "memberVideoList" */ "@/views/default/components/material/VideoList"
              ),
            meta: { title: "videoList", icon: "play-square" },
          },
          {
            path: "audio_list",
            component: () =>
              import(
                /* webpackChunkName: "memberAudioList" */ "@/views/default/components/material/AudioList"
              ),
            meta: { title: "audioList", icon: "audio" },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "memberRecycle" */ "@/views/default/components/material/Recycle"
              ),
            meta: { title: "recycle", icon: "delete" },
          },
        ],
      },
        //團隊
      {
        path: "team",
        redirect: "team/list",
        component: BlankLayout,
        team: true,
        meta: { title: "team" },
        children: [
          {
            path: "list",
            component: () =>
                import(
                    /* webpackChunkName: "memberWork" */ "@/views/default/member/team/List"
                    ),
            meta: { title: "teamMember", icon: "team" },
          },
          {
            path: "info",
            component: () =>
                import(
                    /* webpackChunkName: "memberWork" */ "@/views/default/member/team/Info"
                    ),
            meta: { title: "teamInfo", icon: "info-circle" },
          },
        ],
      },
      {
        path: "account",
        name: "member-account",
        redirect: "account/basic",
        component: BlankLayout,
        meta: { title: "account" },
        children: [
          {
            path: "basic",
            name:"memberAccountBasic",
            component: () =>
              import(
                /* webpackChunkName: "memberBasic" */ "@/views/default/member/account/Basic"
              ),
            meta: { title: "accountBasic", icon: "exception" },
          },
          {
            path: "secure",
            component: () =>
              import(
                /* webpackChunkName: "memberSecure" */ "@/views/default/member/account/Secure"
              ),
            meta: { title: "accountSecure", icon: "safety" },
          },
          {
            path: "order",
            component: () =>
              import("@/views/default/components/OrderDetail/index"),
            meta: { title: "orderDetail", icon: "safety",type:1 },
          },
          {
            path: "orderDetail",
            component: () =>
                import(
                    /* webpackChunkName: "adminUserDetail" */ "@/views/default/components/OrderDetail/Detail"
                    ),
            meta: {
              title: "orderDetails",
              icon: "hdd",
              showBreadcrumb: true,
              hidden: true,
            },
          },
        ],
      },
      {
        path: "hint",
        // name: "member-account",
        redirect: "hint/hintPage",
        component: BlankLayout,
        meta: { title: "hintMessage" },
        hidden: true,
        children: [
          {
            path: "hintPage",
            component: () =>
              import(/* webpackChunkName: "notFound" */ "@/views/default/error/hint"),
              meta: { title: "hintMessage", icon: "safety"},
          },
        ],
      },
    ],
  },
];

export const adminRoutes = [
  {
    path: "/admin",
    redirect: "/admin/home",
    component: AdminLayout,
    children: [
      {
        path: "home",
        name: "admin-home",
        redirect: "home/dashboard",
        component: BlankLayout,
        meta: { title: "home" },
        children: [
          {
            path: "dashboard",
            component: () =>
              import(
                /* webpackChunkName: "adminDashboard" */ "@/views/default/admin/home/Dashboard"
              ),
            meta: { title: "dashboard", icon: "area-chart" },
          },
        ],
      },
      //系統管理：站點設置、素材管理等
      {
        path: "sys",
        redirect: "sys/site",
        component: BlankLayout,
        meta: { title: "sysManage" },
        children: [
          {
            path: "site",
            component: () =>
              import(
                /* webpackChunkName: "adminSite" */ "@/views/default/admin/sys/site.vue"
              ),
            meta: { title: "siteManage", icon: "setting" },
          },
          {
            path: "cate",
            component: () =>
              import(
                /* webpackChunkName: "adminCate" */ "@/views/default/admin/sys/cate.vue"
              ),
            meta: { title: "cateManage", icon: "database" },
          },
          {
            path: "tag",
            component: () =>
              import(
                /* webpackChunkName: "adminTag" */ "@/views/default/admin/sys/tag.vue"
              ),
            meta: { title: "tagManage", icon: "project" },
          },
          {
            path: "icon",
            component: () =>
              import(
                /* webpackChunkName: "adminIcon" */ "@/views/default/admin/sys/Icon"
              ),
            meta: { title: "iconManage", icon: "codepen" },
          },
          {
            path: "advertisement",
            component: () =>
              import(
                /* webpackChunkName: "adminAdvertisement" */ "@/views/default/admin/sys/Advertisement"
              ),
            meta: { title: "advManage", icon: "fund" },
          },
          {
            path: "articleCate",
            component: () =>
              import(
                /* webpackChunkName: "adminArticleType" */ "@/views/default/admin/sys/ArticleCate"
              ),
            meta: { title: "ArtCateManage", icon: "snippets" },
          },
          {
            path: "article",
            component: () =>
              import(
                /* webpackChunkName: "adminArticle" */ "@/views/default/admin/sys/Article"
              ),
            meta: { title: "ArtManage", icon: "book" },
          },
         /* {
            path: "renewRule",
            component: () =>
              import(
                /!* webpackChunkName: "payConfig" *!/ "@/views/default/admin/sys/PayConfig"
              ),
            meta: { title: "renewRule", icon: "pay-circle",type:1 },
          },
          {
            path: "dilatationRule",
            component: () =>
              import(
                /!* webpackChunkName: "payConfig" *!/ "@/views/default/admin/sys/PayConfig"
              ),
            meta: { title: "dilatationRule", icon: "fullscreen",type:2 },
          },*/
          {
            path: "order",
            component: () =>
              import("@/views/default/components/OrderDetail/index"),
            meta: { title: "orderDetail", icon: "safety" },
          },
          {
            path: "orderDetail",
            component: () =>
                import(
                    /* webpackChunkName: "adminUserDetail" */ "@/views/default/components/OrderDetail/Detail"
                    ),
            meta: {
              title: "orderDetails",
              icon: "hdd",
              showBreadcrumb: true,
              hidden: true,
            },
          },
          {
            path: "regionManager",
            component: () =>
              import(
                /* webpackChunkName: "adminAdvertisement" */ "@/views/default/admin/sys/RegionManager"
              ),
            meta: { title: "regionManage", icon: "environment" },
          },
          {
            path: "member",
            component: () =>
              import(
                /* webpackChunkName: "adminSite" */ "@/views/default/admin/sys/Member.vue"
              ),
            meta: { title: "memberScheme", icon: "sketch" },
          },
          {
            path: "contact",
            component: () =>
                import(
                    /* webpackChunkName: "adminSite" */ "@/views/default/admin/sys/Contact.vue"
                    ),
            meta: { title: "contactUs", icon: "phone" },
          },
        ],
      },
      {
        path: "user",
        redirect: "user/list",
        component: BlankLayout,
        meta: { title: "userManage" },
        children: [
          {
            path: "list",
            name:"adminUserList",
            component: () =>
              import(
                /* webpackChunkName: "adminUserList" */ "@/views/default/admin/user/List"
              ),
            meta: { title: "userList", icon: "user" },
          },
          {
            path: "detail",
            component: () =>
              import(
                /* webpackChunkName: "adminUserDetail" */ "@/views/default/admin/user/Detail"
              ),
            meta: {
              title: "userDetail",
              icon: "hdd",
              showBreadcrumb: true,
              hidden: true,
            },
          },
          {
            path: "config",
            component: () =>
              import(
                /* webpackChunkName: "adminUserConfig" */ "@/views/default/admin/user/Config"
              ),
            meta: {
              title: "userConfig",
              icon: "project",
              showBreadcrumb: true,
              hidden: true,
            },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "adminUserRecyle" */ "@/views/default/admin/user/Recycle"
              ),
            meta: { title: "userRecycle", icon: "delete" },
          },
        ],
      },
        //團隊管理
      {
        path: "team",
        redirect: "team/list",
        component: BlankLayout,
        meta: { title: "teamManage" },
        children: [
          {
            path: "list",
            component: () =>
                import(
                    /* webpackChunkName: "adminTeamList" */ "@/views/default/admin/team/List"
                    ),
            meta: { title: "teamList", icon: "team" },
          },
        ],
      },
      {
        path: "agent",
        redirect: "agent/list",
        component: BlankLayout,
        meta: { title: "agentManage" },
        children: [
          {
            path: "list",
            component: () =>
              import(
                /* webpackChunkName: "agentList" */ "@/views/default/admin/agent/List"
              ),
            meta: { title: "agentList", icon: "user" },
          },
          {
            path: "detail",
            component: () =>
              import(
                /* webpackChunkName: "agentDetail" */ "@/views/default/admin/agent/Detail"
              ),
            meta: {
              title: "agentDetail",
              icon: "hdd",
              showBreadcrumb: true,
              hidden: true,
            },
          },
          {
            path: "config",
            component: () =>
              import(
                /* webpackChunkName: "agentConfig" */ "@/views/default/admin/agent/Config"
              ),
            meta: { title: "agentConfig", icon: "project",showBreadcrumb: true, hidden: true },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "agentRecyle" */ "@/views/default/admin/agent/Recycle"
              ),
            meta: { title: "agentSecycle", icon: "delete" },
          },
        ],
      },
      {
        path: "workManage",
        redirect: "workManage/workList",
        component: BlankLayout,
        meta: { title: "workManage" },
        children: [
          {
            path: "workList",
            component: () => import("@/views/default/components/WorkManage/WorkList"),
            meta: {
              title: "workList",
              icon: "project",
              showBreadcrumb: false,
            },
          },
          {
            path: "workRecycle",
            component: () => import("@/views/default/components/WorkManage/WorkRecycle"),
            meta: { title: "workRecycle", icon: "delete" },
          },
        ],
      },
      {
        path: "material",
        redirect: "material/image_list",
        component: BlankLayout,
        meta: { title: "materialList" },
        children: [
          {
            path: "pano_list",
            component: () =>
              import(
                /* webpackChunkName: "memberPanoList" */ "@/views/default/components/material/PanoList"
              ),
            meta: { title: "panoList", icon: "global" },
          },
          {
            path: "panoramic_video",
            component: () =>
              import(
                /* webpackChunkName: "adminPanoramicList" */ "@/views/default/components/material/Panoramic"
              ),
            meta: { title: "panoramic", icon: "codepen-circle" },
          },
          {
            path: "image_list",
            component: () =>
              import(
                /* webpackChunkName: "memberImageList" */ "@/views/default/components/material/ImageList"
              ),
            meta: { title: "imageList", icon: "picture" },
          },
          {
            path: "video_list",
            component: () =>
              import(
                /* webpackChunkName: "memberVideoList" */ "@/views/default/components/material/VideoList"
              ),
            meta: { title: "videoList", icon: "video-camera" },
          },
          {
            path: "audio_list",
            component: () =>
              import(
                /* webpackChunkName: "memberAudioList" */ "@/views/default/components/material/AudioList"
              ),
            meta: { title: "audioList", icon: "audio" },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "memberRecycle" */ "@/views/default/components/material/Recycle"
              ),
            meta: { title: "recycle", icon: "delete" },
          },
        ],
      },
      {
        path: "account",
        name: "member-account",
        redirect: "account/basic",
        component: BlankLayout,
        meta: { title: "account" },
        children: [
          {
            path: "basic",
            component: () =>
              import(
                /* webpackChunkName: "memberBasic" */ "@/views/default/admin/account/Basic"
              ),
            meta: { title: "accountBasic", icon: "exception" },
          },
          {
            path: "secure",
            component: () =>
              import(
                /* webpackChunkName: "memberSecure" */ "@/views/default/admin/account/Secure"
              ),
            meta: { title: "accountSecure", icon: "safety" },
          },
        ],
      },
    ],
  },
];

export const agentRoutes = [
  {
    path: "/agent",
    redirect: "/agent/home",
    component: AgentLayout,
    children: [
      // 數據總攬頁
      {
        path: "home",
        name: "agent-home",
        redirect: "home/dashboard",
        component: BlankLayout,
        meta: { title: "home" },
        children: [
          {
            path: "dashboard",
            component: () =>
              import(
                /* webpackChunkName: "agentDashboard" */ "@/views/default/agent/home/Dashboard"
              ),
            meta: { title: "dashboard", icon: "appstore" },
          },
        ],
      },
      //用戶管理
      {
        path: "manager",
        redirect: "manager/userlist",
        component: BlankLayout,
        meta: { title: "userManager" },
        children: [
          {
            path: "userlist",
            component: () =>
              import(
                /* webpackChunkName: "agentUserList" */ "@/views/default/agent/manager/UserList"
              ),
            meta: { title: "userList", icon: "user" },
          },
          {
            path: "teamUser",
            name:"managerTeamUserList",
            component: () =>
                import(
                    /* webpackChunkName: "adminUserList" */ "@/views/default/agent/manager/TeamUserList.vue"
                    ),
            meta: { title: "userList", icon: "user",hidden: true },
          },
          {
            path: "detail",
            component: () =>
              import(
                /* webpackChunkName: "agentUserDetail" */ "@/views/default/agent/manager/Detail"
              ),
            meta: { title: "userDetail", icon: "hdd", showBreadcrumb: true,hidden: true },
          },
          {
            path: "config",
            component: () =>
              import(
                /* webpackChunkName: "agentConfig" */ "@/views/default/agent/manager/Config"
              ),
            meta: { title: "userConfig", icon: "hdd",showBreadcrumb: true, hidden: true },
          },
          {
            path: "userconfig",
            component: () =>
              import(
                /* webpackChunkName: "agentUserConfig" */ "@/views/default/agent/manager/UserConfig"
              ),
            meta: { title: "userConfig", icon: "project" ,showBreadcrumb: true},
          },
          {
            path: "order",
            component: () =>
              import("@/views/default/components/OrderDetail/index"),
            meta: { title: "orderDetail", icon: "safety",type:2 },
          },
          {
            path: "userrecycle",
            component: () =>
              import(
                /* webpackChunkName: "agentUserRecycle" */ "@/views/default/agent/manager/UserRecycle"
              ),
            meta: { title: "userRecycle", icon: "delete" },
          },
        ],
      },
      //作品管理
      {
        path: "workManage",
        redirect: "workManage/workList",
        component: BlankLayout,
        meta: { title: "workManage" },
        children: [
          {
            path: "workList",
            component: () => import("@/views/default/components/WorkManage/WorkList"),
            meta: {
              title: "workList",
              icon: "project",
              showBreadcrumb: false,
            },
          },
          {
            path: "workRecycle",
            component: () => import("@/views/default/components/WorkManage/WorkRecycle"),
            meta: { title: "workRecycle", icon: "delete" },
          },
        ],
      },
      //素材審核
      {
        path: "material",
        redirect: "material/list",
        component: BlankLayout,
        meta: { title: "materialAduit" },
        children: [
          {
            path: "list",
            component: () =>
              import(
                /* webpackChunkName: "agentMaterialAduit" */ "@/views/default/agent/material/List"
              ),
            meta: { title: "materialList", icon: "wallet" },
          },
        ],
      },
      {
        path: "materialList",
        redirect: "materialList/image_list",
        component: BlankLayout,
        meta: { title: "materialList" },
        children: [
          {
            path: "image_list",
            component: () =>
              import(
                /* webpackChunkName: "memberImageList" */ "@/views/default/components/material/ImageList"
              ),
            meta: { title: "imageList", icon: "picture" },
          },
          {
            path: "video_list",
            component: () =>
              import(
                /* webpackChunkName: "memberVideoList" */ "@/views/default/components/material/VideoList"
              ),
            meta: { title: "videoList", icon: "video-camera" },
          },
          {
            path: "audio_list",
            component: () =>
              import(
                /* webpackChunkName: "memberAudioList" */ "@/views/default/components/material/AudioList"
              ),
            meta: { title: "audioList", icon: "audio" },
          },
          {
            path: "recycle",
            component: () =>
              import(
                /* webpackChunkName: "memberRecycle" */ "@/views/default/components/material/Recycle"
              ),
            meta: { title: "recycle", icon: "delete" },
          },
        ],
      },
      //帳戶頁面
      {
        path: "account",
        name: "agent-account",
        redirect: "account/basic",
        component: BlankLayout,
        meta: { title: "accountManager" },
        children: [
          {
            path: "basic",
            component: () =>
              import(
                /* webpackChunkName: "agentBasic" */ "@/views/default/agent/account/Basic"
              ),
            meta: { title: "basicSetting", icon: "setting" },
          },
          {
            path: "safe",
            component: () =>
              import(
                /* webpackChunkName: "agentSafe" */ "@/views/default/agent/account/Safe"
              ),
            meta: {
              title: "safeSetting",
              showBreadcrumb: true,
              icon: "safety",
            },
          },
        ],
      },
      {
        path: "hint",
        // name: "member-account",
        redirect: "hint/hintPage",
        component: BlankLayout,
        meta: { title: "hintMessage" },
        hidden: true,
        children: [
          {
            path: "hintPage",
            component: () =>
              import(/* webpackChunkName: "notFound" */ "@/views/default/error/hint"),
              meta: { title: "hintMessage", icon: "safety"},
          },
        ],
      },
    ],
  },
];

export const mobileRoutes = [
  {
    path: "/mobile",
    redirect: "/mobile/member/mine",
    component: MobileLayout,
    children: [
      {
        path: "member/mine",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberMine" */ "@/views/default/mobile/member/mine"
          ),
      },
      {
        path: "publish",
        name: "mbpublish",
        hidden: true,
        component: () =>
          import(
            /* webpackChunkName: "mbPublish" */ "../views/default/publish/mb_publish"
          ),
        meta: { type: "mobile" },
      },
      {
        path: "live",
        name: "mbpublishlive",
        hidden: true,
        component: () =>
          import(
            /* webpackChunkName: "mbPublish" */ "../views/default/publish/mb_publish/live"
          ),
        meta: { type: "mobile" },
      },
      {
        path: "member/work/list",
        name: "mbWorkList",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberWorkList" */ "@/views/default/mobile/member/work/List"
          ),
      },
      {
        path: "member/work/recycle",
        name: "mbWorkRecycle",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberWorkRecycle" */ "@/views/default/mobile/member/work/Recycle"
          ),
      },
      {
        path: "member/personal/info",
        name: "personal/info",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberMine" */ "@/views/default/mobile/member/mine/PersonalInfo"
          ),
      },
      {
        path: "member/personal/secure",
        name: "personal/secure",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberMine" */ "@/views/default/mobile/member/mine/Secure"
          ),
      },
      {
        path: "member/material",
        name:"mbMaterialManage",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberMaterial" */ "@/views/default/mobile/member/material"
          ),
      },
      {
        path: "member/material/recycle",
        name: "mbMaterialRecycle",
        component: () =>
          import(
            /* webpackChunkName: "mobileMemberRecycle" */ "@/views/default/mobile/member/material/Recycle"
          ),
      },
      {
        path: "hintPage",
        component: () =>
          import(/* webpackChunkName: "notFound" */ "@/views/default/error/hint"),
          meta: { title: "hintMessage", icon: "safety"},
      },
    ],
  },
];

const createRouter = () => new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  // routes: [...constantRoutes, ...adminRoutes, ...memberRoutes, ...agentRoutes]
  routes: process.env.VUE_APP_ENV == "offline" ? offlineRoutes : constantRoutes,
});

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}


//解決路由重複點擊撥錯提示
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => {
//     console.log("===router===",err);
//     return err;
//   });
// };


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

export default router;
